import styled from "styled-components";
import { headerCommonStyle } from "./common.js";

export const H3 = styled.h3`
  ${headerCommonStyle}
  font-size: ${({ theme }) => theme.fontSize.xl};
`;
